import React, { useEffect, useState } from "react";
import FilterListIcon from "@mui/icons-material/FilterList";
import { styled } from "@mui/system";
import { Box, Button, Popover, Toolbar } from "@mui/material";
import { Form, Formik } from "formik";
import InputField from "../../../../components/formFields/InputField";
import {
  setAssessmentDate,
  setInvoiceNumber,
  setMemberName,
  setNaicCode,
  setAssessmentClass,
  setEmailStatus,
  setEmail,
  setCommunicationType,
  setCommunicationDate,
  setEmailDate,
} from "../../../../store/slices/FilterSlice";
import { useDispatch, useSelector } from "react-redux";
import { setStatus } from "../../../../store/slices/FilterSlice";
import DatePickerField from "../../../../shared/components/DatePickerField";
import SelectField from "../../../../shared/components/SelectField";
import { useGetInvoicesStatusesQuery } from "../../../../services/InsuranceService";

const StyledPopover = styled(Popover)({
  "& .MuiPaper-root": {
    padding: "24px",
    height: "500px",
    width: "300px",
    flexDirection: "column",
    display: "flex",
    justifyContent: "space-between",
  },
});

const FieldContainer = styled(Box)({
  width: "252px",
  margin: "5px 0px",
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  "& .MuiFormLabel-root": {
    marginBottom: "9px",
  },
  "& .MuiInputBase-root": {
    minWidth: "100%",
    minHeight: "30px",
    border: "1px solid #b2b9dc",
    borderRadius: "4px",
    "& input": {
      paddingLeft: "10px",
      paddingRight: "10px",
      paddingBottom: "0px",
      paddingTop: "0px",
    },
  },
});

const StyledButton = styled(Button)(({ theme, isfull }) => ({
  backgroundColor: isfull ? theme.palette.primary.main : "",
  color: isfull ? theme.palette.info.contrastText : theme.palette.primary.main,
  svg: {
    color: isfull ? theme.palette.info.contrastText : theme.palette.primary.main,
  },
}));

export const communicationTypes = [
  {
    "id": 1,
    "code": "Pre-assesment",
    "name": "Pre-assesment",
  },
  {
    "id": 2,
    "code": "Annual Meeting Notice",
    "name": "Annual Meeting Notice",
  },
];

export const assessmentClasses = [
  {
    "id": 1,
    "code": "Pre-assesment",
    "name": "Pre-assesment",
  },
  {
    "id": 3,
    "code": "Proxy",
    "name": "Proxy",
  },
];

export const emailStatuses = [
  {
    "id": 1,
    "code": "Ready for Send",
    "name": "Ready for Send",
  },
  {
    "id": 2,
    "code": "Pending",
    "name": "Pending",
  },
  {
    "id": 3,
    "code": "Sent",
    "name": "Sent",
  },
  {
    "id": 4,
    "code": "Failed",
    "name": "Failed",
  },
];

export const TableFilter = (props) => {
  const { onApplyFilters, type } = props;
  const {
    naicCode,
    memberName,
    status,
    assessmentDate,
    invoiceNumber,
    assessmentClass,
    emailStatus,
    communicationType,
    communicationDate,
    emailDate,
    email,
  } = useSelector((state) => state.filter);
  const { data: invoicesStatuses } = useGetInvoicesStatusesQuery("");
  
  const updateKey = (arr) => arr?.map(({ id, name, ...rest }) => ({ id, code: name, ...rest }));

  const transformedStatuses = updateKey(invoicesStatuses)

  const dispatch = useDispatch();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const onFilterClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    return () => {
      onReset();
    };
  }, []);

  const onReset = (e) => {
    dispatch(setNaicCode(null));
    dispatch(setMemberName(null));
    dispatch(setStatus(null));
    dispatch(setAssessmentClass(null));
    dispatch(setCommunicationType(null));
    dispatch(setCommunicationDate(null));
    dispatch(setEmailDate(null));
    dispatch(setEmailStatus(null));
    dispatch(setInvoiceNumber(null));
    dispatch(setEmail(null));
    setAnchorEl(null);
    onApplyFilters({
      naicCode: null,
      memberName: null,
      status: null,
      assessmentDate: null,
      invoiceNumber: null,
      communicationType: null,
      communicationDate: null,
      emailDate: null,
      email: null,
    });
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  const handleSubmit = (value) => {
    dispatch(setCommunicationType(value.communicationType));
    dispatch(setCommunicationDate(value.communicationDate));
    dispatch(setEmailDate(value.emailDate));
    dispatch(setNaicCode(value.naicCode));
    dispatch(setMemberName(value.memberName));
    dispatch(setStatus(value.status));
    dispatch(setAssessmentDate(value.assessmentDate));
    dispatch(setAssessmentClass(value.assessmentClass));
    dispatch(setEmailStatus(value.emailStatus));
    dispatch(setInvoiceNumber(value.invoiceNumber));
    dispatch(setEmail(value.email));

    onApplyFilters(value);
    setAnchorEl(null);
  };
  return (
    <Toolbar sx={{ minHeight: "0px !important" }}>
      <StyledButton
        onClick={onFilterClick}
        startIcon={<FilterListIcon />}
        variant="outlined"
        isfull={
          naicCode ||
          memberName ||
          communicationType ||
          communicationDate ||
          emailStatus ||
          email ||
          emailDate
        }
      >
        Filter
      </StyledButton>
      <StyledPopover
        id={"filter-popover"}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
      >
        <Formik
          initialValues={{
            naicCode,
            email,
            memberName,
            status,
            assessmentDate,
            assessmentClass,
            invoiceNumber,
            emailStatus,
            communicationType,
            communicationDate,
            emailDate,
          }}
          onSubmit={handleSubmit}
          enableReinitialize={true}
        >
          {() => (
            <Form id={"filterForm"}>
              <FieldContainer>
                <InputField name={"naicCode"} label={"NAIC Code"} />
              </FieldContainer>
              <FieldContainer>
                <InputField name={"memberName"} label={"Member Name"} />
              </FieldContainer>
              <FieldContainer>
                <InputField name={"email"} label={"Email"} />
              </FieldContainer>
              <FieldContainer>
                <SelectField
                  name={"emailStatus"}
                  label={"Email status"}
                  data={emailStatuses}
                  width="253px"
                />
              </FieldContainer>
              <FieldContainer>
                <DatePickerField name={"emailDate"} label={"Email Date"} width = "100%"/>
              </FieldContainer>
              <FieldContainer>
                <SelectField
                  name={"communicationType"}
                  label={"Communication Type"}
                  data={communicationTypes}
                  width="253px"
                />
              </FieldContainer>
              <FieldContainer>
                <DatePickerField name={"communicationDate"} label={"Communication Date"} width = "100%"/>
              </FieldContainer>
              <Box sx={{ display: "flex"}}>
                <StyledButton type="submit">Apply</StyledButton>
                <StyledButton onClick={onReset}>Reset</StyledButton>
              </Box>
            </Form>
          )}
        </Formik>
      </StyledPopover>
    </Toolbar>
  );
};
